import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/redux-store/hooks";
import { useNavigate } from "react-router-dom";
import { ConfirmFeedbackModal } from "src/components/Modals/ConfirmationModal";
import { resetUser, clearChatState } from "src/redux/redux-store";
import { useAuth } from "src/hooks/useAuth";
import { userRoutes } from "src/navigators/routes/user";
import { authRoutes } from "src/navigators/routes/auth";
import { CustomButton } from "src/components/common/Buttons/CustomButton";
import { Text } from "@mantine/core";
import { useChat } from "src/hooks/useChat";
import { Link } from "react-router-dom";

export const ChildViewReportSidebar = () => {
  const [isSignOutModalOpen, setIsSignOutModalOpen] = useState(false);
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { logout } = useAuth();
  const { activeSubject } = useChat();
  const handleSignOut = async () => {
    dispatch(resetUser());
    dispatch(clearChatState());
    logout();
    navigate(authRoutes.LOGIN, { replace: true });
  };
  return (
    <div className="flex flex-col h-dvh justify-between text-gray-800 bg-white w-full p-4 pt-2 md:pt-0">
      <ConfirmFeedbackModal
        title="Sign Out"
        feedback="Are you sure you want to sign out?"
        onConfirm={handleSignOut}
        onClose={() => setIsSignOutModalOpen(false)}
        visible={isSignOutModalOpen}
        confirmLabel="Sign Out"
      />
      <div className="flex items-center space-x-3 mb-5 md:my-5">
        <div>
          <Text className="font-bold text-xl">{user.name}</Text>
          <Text className="text-sm text-gray-600">{user.level}</Text>
          <Text className="text-sm text-gray-600">{activeSubject}</Text>
        </div>
      </div>
      <div className="flex flex-col justify-between h-full">
        <div>
          <Link to={userRoutes.DASHBOARD.replace("/parent", "")}>
            <CustomButton
              variant="outline"
              size="default"
              alignment="left"
              className="text-sm w-full"
              leftIcon="back"
            >
              Back to Chats
            </CustomButton>
          </Link>
        </div>
        <div className="mt-4">
          <CustomButton
            onClick={() => setIsSignOutModalOpen(true)}
            variant="ghost"
            size="default"
            leftIcon="logout"
            alignment="left"
            className="text-sm w-full"
          >
            Sign Out
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
